import { Box, Typography, Flex, Button, Picture } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"
import { Link } from "react-router-dom"
import styled from "styled-components"

const TextBlock = styled(Box).attrs((props) => ({
  left: { tablet: props.textPosition === "left" ? "5%" : props.textPosition },
  right: { tablet: props.textPosition === "right" ? "5%" : props.textPosition },
  top: { _: "60%", tablet: "50%" },
  width: { _: "100%", tablet: "260px" },
  ...props,
}))`
  position: absolute;
  ${(props) => props.theme.mediaQueries.tablet`
    transform: translateY(-50%);
  `}
`
const ShopNowBtn = styled(Button)`
  background-color: white;
  box-shadow: 2px 3px 4px 0px #ccc;
  color: black;
  font-size: 14px;
  font-weight: 300;
  padding: 8px 48px;
  ${(props) =>
    props.primary &&
    `
    background-color: ${props.theme.colors.primary};
    box-shadow: none;
    color: white;
    font-size: 16px;
    font-weight: 500;
    padding: 10px 20px;
  `}
`
const Cta = ({ data, primary, imageStyle }) => {
  return (
    <Flex
      addYPadding
      alignItems="center"
      contain
      flexDirection="column"
      textAlign="center"
    >
      {data.map((item, index) => (
        <Flex
          justifyContent="center"
          key={`${item.title}-${index}`}
          mb={2}
          position="relative"
          width={{ _: "100%", tablet: "825px" }}
        >
          <Box
            as={Link}
            data-lc="cta"
            height="100%"
            to={item.link}
            width="100%"
          >
            <Picture
              alt={item.title}
              srcSet={[
                {
                  height: "214",
                  media: "(max-width: 767px)",
                  sizes: "100vw",
                  srcSet: `
                    ${sl.config.jewlr_asset_url}images/info/jewlr/${item.image}-mobile.jpg 295w,
                    ${sl.config.jewlr_asset_url}images/info/jewlr/${item.image}-mobile-2x.jpg 590w,
                  `,
                  width: "295",
                },
                {
                  height: "160",
                  media: "(min-width: 768px)",
                  sizes: "825px",
                  srcSet: `
                    ${sl.config.jewlr_asset_url}images/info/jewlr/${item.image}-desktop.jpg 686w,
                    ${sl.config.jewlr_asset_url}images/info/jewlr/${item.image}-desktop-2x.jpg 1280w,
                  `,
                  width: "686",
                },
              ]}
              {...imageStyle}
            />

            <TextBlock textPosition={item.textPosition}>
              <Typography fontSize={22} mb={2}>
                {item.title}
              </Typography>
              <ShopNowBtn primary={primary}>{item.btn}</ShopNowBtn>
            </TextBlock>
          </Box>
        </Flex>
      ))}
    </Flex>
  )
}

Cta.propTypes = {
  data: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  imageStyle: PropTypes.object,
  primary: PropTypes.bool,
}
export default Cta
